/**
 * Project panel
 * TypeSelection.js
 * Created by stefensuhat on 2019-03-21 15:22
 */

import { Box, MenuItem, Select, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import MenuSearch from '../../menu/MenuSearch';
import PackageSearch from '../../package/PackageSearch';

const propTypes = {};
const defaultProps = {};

function TypeSelection({ onRowClick }) {
    const [type, setType] = useState('packages');

    function handleChange(e) {
        setType(e.target.value);
    }

    return (
        <div>
            <Box mb={2}>
                <Typography variant="overline">Choose category to search</Typography>

                <Select
                    fullWidth
                    displayEmpty
                    value={type}
                    onChange={handleChange}
                    variant="filled"
                    placeholder="Choose Select to Search"
                >
                    <MenuItem value="menus">Menu</MenuItem>
                    <MenuItem value="packages">Package</MenuItem>
                </Select>
            </Box>

            {
                type === 'menus' ? <MenuSearch onRowClicked={onRowClick} />
                    : <PackageSearch onRowClicked={onRowClick} />
            }
        </div>
    );
}

TypeSelection.propTypes = propTypes;
TypeSelection.defaultProps = defaultProps;

export default TypeSelection;
